import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.RegisterPage.RegisterForm', {
    emailRequired: 'Enter your email',
    emailInvalid: 'The email address is not valid',
    emailPlaceholder: 'Enter your email address',
    email: 'Enter your business email',
    agreement: "I agree to receive ApprovalMax's news, insights and special offers",
    submitButton: 'Sign up for free',
});
